import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProgramCard = ({ program, onStartProgram }) => {
  const navigate = useNavigate();

  const getDifficultyColor = (level) => {
    const colors = {
      beginner: 'bg-success/10 text-success',
      intermediate: 'bg-warning/10 text-warning',
      advanced: 'bg-error/10 text-error',
    };
    return colors?.[level?.toLowerCase()] || colors?.beginner;
  };

  const handleCardClick = () => {
    if (program?.isActive) {
      onStartProgram(program);
    }
  };

  return (
    <div 
      className={`card hover:shadow-xl transition-all duration-250 ${program?.isActive ? 'cursor-pointer' : ''}`}
      onClick={handleCardClick}
    >
      <div className="relative h-48 md:h-56 lg:h-64 -mx-9 -mt-9 mb-6 overflow-hidden rounded-t-xl">
        <Image
          src={program?.image}
          alt={program?.imageAlt}
          className="w-full h-full object-cover"
        />
        {program?.isRecommended && (
          <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-medium flex items-center gap-2">
            <Icon name="Sparkles" size={14} />
            AI Recommended
          </div>
        )}
        {program?.isActive && (
          <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-medium">
            Active Program
          </div>
        )}
      </div>
      <div className="space-y-4">
        <div>
          <div className="flex items-start justify-between gap-3 mb-2">
            <h3 className="text-xl font-heading font-semibold text-foreground line-clamp-2">
              {program?.name}
            </h3>
            <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getDifficultyColor(program?.difficulty)}`}>
              {program?.difficulty}
            </span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {program?.description}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <span>{program?.duration}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Calendar" size={16} color="var(--color-primary)" />
            <span>{program?.frequency}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Dumbbell" size={16} color="var(--color-primary)" />
            <span>{program?.equipment}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Target" size={16} color="var(--color-primary)" />
            <span>{program?.goal}</span>
          </div>
        </div>

        {program?.progress !== undefined && (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Progress</span>
              <span className="font-medium text-foreground">{program?.progress}%</span>
            </div>
            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all duration-500"
                style={{ width: `${program?.progress}%` }}
              />
            </div>
          </div>
        )}

        <div className="flex items-center gap-3 pt-2">
          {program?.isActive ? (
            <Button 
              variant="default" 
              fullWidth
              iconName="Play"
              iconPosition="left"
              onClick={(e) => {
                e?.stopPropagation();
                onStartProgram(program);
              }}
            >
              Continue Workout
            </Button>
          ) : (
            <Button 
              variant="outline" 
              fullWidth
              onClick={(e) => {
                e?.stopPropagation();
                onStartProgram(program);
              }}
            >
              Start Program
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;